import './validator/setValidationLocale';
import { Form as F } from './Form';
export const Form = F;
export default Form;
export * from './hooks';
export * from './components';
export * from './utils';
export * from './FormUI/';
export * from './Other';
//# sourceMappingURL=es/index.js.map